import React, { useState } from "react";
import { feedbackModalMessage } from "../../../../services/complianceAPIServices";
import Modal from "../../../common/Modal";

const ratingOptions = [
  { value: 1, label: "Poor" },
  { value: 2, label: "Fair" },
  { value: 3, label: "Good" },
  { value: 4, label: "Very Good" },
  { value: 5, label: "Excellent" },
];

export default function FeedbackModal({ show, onClose, setFeedbackSubmitting }) {
  const [rating, setRating] = useState(null);
  const [message, setMessage] = useState("");
  const [hoveredRating, setHoveredRating] = useState(null);

  const resetForm = () => {
    setRating(null);
    setMessage("");
    setHoveredRating(null);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async () => {
    // Combine rating and message into a single body for the API
    const ratingText = rating
      ? `${rating} - ${ratingOptions.find((r) => r.value === rating)?.label}`
      : "No rating provided";
    const combinedMessage = `Rating: ${ratingText}\n\nComments:\n${message || "No comments provided"}`;

    handleClose();
    setFeedbackSubmitting();
    await feedbackModalMessage(combinedMessage, ratingText);
    setFeedbackSubmitting();
    alert("Feedback Sent!");
  };

  return (
    <Modal show={show} onClose={handleClose}>
      <div className="modal-header border-0 pb-0">
        <h5 className="modal-title fw-semibold">Share Your Feedback</h5>
        <button
          type="button"
          className="btn-close"
          onClick={handleClose}
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body pt-2">
        <p className="text-muted small mb-3">
          Help us improve! Your feedback shapes the future of this application.
        </p>

        {/* Star Rating Section */}
        <div className="mb-4">
          <label className="form-label fw-medium mb-2">
            How would you rate your experience?
          </label>
          <div className="d-flex gap-1 justify-content-center">
            {ratingOptions.map((option) => {
              const isFilled =
                (hoveredRating && option.value <= hoveredRating) ||
                (!hoveredRating && rating && option.value <= rating);
              return (
                <button
                  key={option.value}
                  type="button"
                  className="btn p-1 border-0"
                  style={{
                    fontSize: "2rem",
                    color: isFilled ? "#ffc107" : "#dee2e6",
                    transition: "all 0.15s ease",
                    transform:
                      hoveredRating === option.value ? "scale(1.2)" : "scale(1)",
                    cursor: "pointer",
                  }}
                  onClick={() => setRating(option.value)}
                  onMouseEnter={() => setHoveredRating(option.value)}
                  onMouseLeave={() => setHoveredRating(null)}
                  title={option.label}
                >
                  &#9733;
                </button>
              );
            })}
          </div>
        </div>

        {/* Comments Section */}
        <div className="mb-3">
          <label htmlFor="feedbackComments" className="form-label fw-medium">
            Any additional comments?{" "}
            <span className="text-muted fw-normal">(optional)</span>
          </label>
          <textarea
            id="feedbackComments"
            className="form-control"
            rows="4"
            placeholder="Tell us what you liked, what could be better, or any suggestions you have..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={{ resize: "none" }}
          ></textarea>
        </div>
      </div>
      <div className="modal-footer border-0 pt-0">
        <button type="button" className="btn btn-secondary" onClick={handleClose}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          style={{ backgroundColor: "#385EA4", borderColor: "#385EA4" }}
          onClick={handleSubmit}
          disabled={!rating && !message.trim()}
        >
          Submit Feedback
        </button>
      </div>
    </Modal>
  );
}
